import { useEffect, useState } from 'react'

import { getWheelItems } from 'sanity'

import type { WheelItemsData, WheelItem } from './wheelData'

export default function useWheelItemsData() {
  const [wheelItems, setWheelItems] = useState<WheelItemsData | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setWheelItems(null)
      const data = await fetchWheelItems()
      setWheelItems(data)
    }
    fetchData()
  }, [])

  return wheelItems
}

async function fetchWheelItems(): Promise<WheelItemsData> {
  const { wheelItemsData } = await import('./wheelData')

  try {
    const wheelItemsFetched = await getWheelItems()
    const updatedWheelItemsData: WheelItemsData = { ...wheelItemsData }
    let dataNeedUpdate = false
    wheelItemsFetched.forEach((item) => {
      const { key, label, description, descriptionAI, descriptionShort } = item
      if (typeof key === 'string' && key in updatedWheelItemsData) {
        const existingItem = updatedWheelItemsData[key as WheelItem]
        let itemNeedUpdate = false
        if (typeof label === 'string' && label.length) {
          existingItem.label.label = label
          itemNeedUpdate = true
        }
        if (typeof description === 'object' && description !== null) {
          existingItem.description = description
          itemNeedUpdate = true
        } else if (typeof descriptionAI === 'object' && descriptionAI !== null) {
          existingItem.description = descriptionAI
          itemNeedUpdate = true
        }
        if (typeof descriptionShort === 'object' && descriptionShort !== null) {
          existingItem.descriptionShort = descriptionShort
          itemNeedUpdate = true
        }
        if (itemNeedUpdate) {
          updatedWheelItemsData[key as WheelItem] = {
            ...existingItem,
          }
          dataNeedUpdate = true
        }
      }
    })
    if (dataNeedUpdate) {
      return updatedWheelItemsData
    }
  } catch (error) {
    console.error('Failed to fetch wheel items:', error)
  }
  return wheelItemsData
}
